import { BrowserRouter, Route, Routes } from "react-router-dom";
import Login from "./pages/Login.js";
import MenuPrincipal from "./pages/MenuPrincipal.js";
import CategoriaFormularios from "./pages/CategoriaFormularios.js";
import CategoriaFormulariosReportes from "./pages/CategoriaFormulariosReportes.js";
import ListadoFormulariosCategoriasDiario from "./pages/ListadoFormulariosDiario.js";
import ListadoFormulariosCategoriasSemanal from "./pages/ListadoFormulariosSemanal.js";
import ListadoFormulariosCategoriasQuincenal from "./pages/ListadoFormulariosQuincenal.js";
import ListadoFormulariosCategoriasMensual from "./pages/ListadoFormulariosMensual.js";
import AccesoDenegado from "./pages/AccesoDenegado.js";
import PageNotFound from "./pages/PAGE_NOT_FOUND.js";
import RutaProtegida from "./components/RutaProtegida.js";

// Reportes
import ReportePDSPRFR006 from './pages/reportes/PDS-PF-FR-006.js';
import ReportePDSCCFR001 from './pages/reportes/PDS-CC-FR-001.js';
import ReportePDSCCFR004 from './pages/reportes/PDS-CC-FR-004.js';
import ReportePDSCCFR008 from './pages/reportes/PDS-CC-FR-008.js';
import ReportePDSCCFR009 from './pages/reportes/PDS-CC-FR-009.js';
import ReportePDSCCFR036 from './pages/reportes/PDS-CC-FR-036.js';
import ReportePDSCCFR028 from './pages/reportes/PDS-CC-FR-028.js';
import ReportePDSCCFR042 from './pages/reportes/PDS-CC-FR-042.js';
import ReportePDSCCFR007 from './pages/reportes/PDS-CC-FR-007.js';
import ReportePDSCCFR002 from './pages/reportes/PDS-CC-FR-002.js';
import ReportePDSCCFR050 from './pages/reportes/PDS-CC-FR-050.js';
import ReportePDSCCFR005 from './pages/reportes/PDS_CC_FR_005.js';
import ReportePDSCCFR011 from './pages/reportes/PDS_CC_FR_011.js';
import ReportePDSCCFR010 from './pages/reportes/PDS_CC_FR_010.js';
import ReportePDSCCFR013 from './pages/reportes/PDS_CC_FR_013.js';
import ReportePDSCCFR056 from './pages/reportes/PDS_CC_FR_056.js';
import ReportePDSCCFR014 from './pages/reportes/PDS_CC_FR_014.js';
import ReportePDSCCFR060 from './pages/reportes/PDS_CC_FR_060.js';
import ReportePDSCCFR061 from './pages/reportes/PDS_CC_FR_061.js';
import ReportePDSCCFR025 from './pages/reportes/PDS_CC_FR_025.js';
import ReportePDSCCFR003 from './pages/reportes/PDS_CC_FR_003.js';
import ReportePDSCCFR063 from './pages/reportes/PDS-CC-FR-063.js';
import ReportePDSCCFR041 from './pages/reportes/PDS_CC_FR_041.js';
import ReportePDSCCFR004V3 from './pages/reportes/PDS_CC_FR_004_V3.js';
import MantenimientoRespuestas from './pages/MantenimientoRespuestas.js';

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/login" element={<Login />} />

        <Route path="/menu-general" element={<RutaProtegida><MenuPrincipal /></RutaProtegida>} />
        <Route
          path="/menu-categorias"
          element={
            <RutaProtegida areasPermitidas={[1, 7]}>
              <CategoriaFormularios />
            </RutaProtegida>
          }
        />
        <Route path="/menu-categorias-reportes" element={<RutaProtegida><CategoriaFormulariosReportes /></RutaProtegida>} />
        <Route path="/menu-listado-categorias-diario" element={<RutaProtegida><ListadoFormulariosCategoriasDiario /></RutaProtegida>} />
        <Route path="/menu-listado-categorias-semanal" element={<RutaProtegida><ListadoFormulariosCategoriasSemanal /></RutaProtegida>} />
        <Route path="/menu-listado-categorias-quincenal" element={<RutaProtegida><ListadoFormulariosCategoriasQuincenal /></RutaProtegida>} />
        <Route path="/menu-listado-categorias-mensual" element={<RutaProtegida><ListadoFormulariosCategoriasMensual /></RutaProtegida>} />
        <Route
  path="/mantenimiento-respuestas"
  element={
    <RutaProtegida areasPermitidas={[7]}>
      <MantenimientoRespuestas />
    </RutaProtegida>
  }
/>
        {/* Reportes protegidos */}
        <Route path="/reporte-PDS-PR-FR-006" element={<RutaProtegida><ReportePDSPRFR006 /></RutaProtegida>} />
        <Route path="/reporte-PDS-CC-FR-001" element={<RutaProtegida><ReportePDSCCFR001 /></RutaProtegida>} />
        <Route path="/reporte-PDS-CC-FR-004" element={<RutaProtegida><ReportePDSCCFR004 /></RutaProtegida>} />
        <Route path="/reporte-PDS-CC-FR-008" element={<RutaProtegida><ReportePDSCCFR008 /></RutaProtegida>} />
        <Route path="/reporte-PDS-CC-FR-009" element={<RutaProtegida><ReportePDSCCFR009 /></RutaProtegida>} />
        <Route path="/reporte-PDS-CC-FR-036" element={<RutaProtegida><ReportePDSCCFR036 /></RutaProtegida>} />
        <Route path="/reporte-PDS-CC-FR-028" element={<RutaProtegida><ReportePDSCCFR028 /></RutaProtegida>} />
        <Route path="/reporte-PDS-CC-FR-042" element={<RutaProtegida><ReportePDSCCFR042 /></RutaProtegida>} />
        <Route path="/reporte-PDS-CC-FR-007" element={<RutaProtegida><ReportePDSCCFR007 /></RutaProtegida>} />
        <Route path="/reporte-PDS-CC-FR-002" element={<RutaProtegida><ReportePDSCCFR002 /></RutaProtegida>} />
        <Route path="/reporte-PDS-CC-FR-050" element={<RutaProtegida><ReportePDSCCFR050 /></RutaProtegida>} />
        <Route path="/reporte-PDS-CC-FR-005" element={<RutaProtegida><ReportePDSCCFR005 /></RutaProtegida>} />
        <Route path="/reporte-PDS-CC-FR-011" element={<RutaProtegida><ReportePDSCCFR011 /></RutaProtegida>} />
        <Route path="/reporte-PDS-CC-FR-010" element={<RutaProtegida><ReportePDSCCFR010 /></RutaProtegida>} />
        <Route path="/reporte-PDS-CC-FR-013" element={<RutaProtegida><ReportePDSCCFR013 /></RutaProtegida>} />
        <Route path="/reporte-PDS-CC-FR-056" element={<RutaProtegida><ReportePDSCCFR056 /></RutaProtegida>} />
        <Route path="/reporte-PDS-CC-FR-014" element={<RutaProtegida><ReportePDSCCFR014 /></RutaProtegida>} />
        <Route path="/reporte-PDS-CC-FR-060" element={<RutaProtegida><ReportePDSCCFR060 /></RutaProtegida>} />
        <Route path="/reporte-PDS-CC-FR-061" element={<RutaProtegida><ReportePDSCCFR061 /></RutaProtegida>} />
        <Route path="/reporte-PDS-CC-FR-025" element={<RutaProtegida><ReportePDSCCFR025 /></RutaProtegida>} />
        <Route path="/reporte-PDS-CC-FR-003" element={<RutaProtegida><ReportePDSCCFR003 /></RutaProtegida>} />
        <Route path="/reporte-PDS-CC-FR-063" element={<RutaProtegida><ReportePDSCCFR063 /></RutaProtegida>} />
        <Route path="/reporte-PDS-CC-FR-041" element={<RutaProtegida><ReportePDSCCFR041 /></RutaProtegida>} />
        <Route path="/reporte-PDS-CC-FR-004-V3" element={<RutaProtegida><ReportePDSCCFR004V3 /></RutaProtegida>} />
        {/* Rutas públicas */}
        <Route path="/acceso-denegado" element={<AccesoDenegado />} />
        <Route path="*" element={<PageNotFound />} />
      </Routes>
    </BrowserRouter>
  );
}